import { useNavigate } from "react-router-dom";

import type { StaffMyPageIncome } from "../../types";

interface Props {
  income: StaffMyPageIncome | undefined;
}

export function IncomeComp({ income }: Props) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center gap-6 py-2">
      {/* 未结算金额 */}
      <button
        onClick={() => navigate("/workspace/money/capital")}
        className="flex-1 text-center py-3 rounded-xl active:scale-[0.98] transition-all"
      >
        <div className="text-xl font-bold" style={{ color: "#EF4444" }}>¥{income?.freeze_price ?? 0}</div>
        <div className="flex items-center justify-center gap-0.5 mt-1">
          <span className="text-xs text-gray-500">未结算金额</span>
          <i className="ri-arrow-right-s-line text-xs text-gray-300" />
        </div>
      </button>

      {/* 分割线 */}
      <div className="w-px h-10 bg-gray-100 shrink-0" />

      {/* 可提现金额 */}
      <button
        onClick={() => navigate("/workspace/money/capital")}
        className="flex-1 text-center py-3 rounded-xl active:scale-[0.98] transition-all"
      >
        <div className="text-xl font-bold" style={{ color: "#FF6B35" }}>¥{income?.remain_price ?? 0}</div>
        <div className="flex items-center justify-center gap-0.5 mt-1">
          <span className="text-xs text-gray-500">可提现金额</span>
          <i className="ri-arrow-right-s-line text-xs text-gray-300" />
        </div>
      </button>
    </div>
  );
}
